if (typeof AI == 'undefined') {
    AI = {};
}

(function(AI) {
    'use strict';

    var CUSTOM_MAP_STYLE_ID = 'styled_map';
    var CUSTOM_MAP_STYLES = [
        {
            featureType: 'landscape',
            stylers: [
                { hue: '#FFBB00' },
                { saturation: 43.400000000000006 },
                { lightness: 37.599999999999994 },
                { gamma: 1 }
            ]
        },
        {
            featureType: 'road.highway',
            stylers: [
                { hue: '#FFC200' },
                { saturation: -61.8 },
                { lightness: 45.599999999999994 },
                { gamma: 1 }
            ]
        },
        {
            featureType: 'road.arterial',
            stylers: [
                { hue: '#FF0300' },
                { saturation: -100 },
                { lightness: 51.19999999999999 },
                { gamma: 1 }
            ]
        },
        {
            featureType: 'road.local',
            stylers: [{ hue: '#FF0300' }, { saturation: -100 }, { lightness: 52 }, { gamma: 1 }]
        },
        {
            featureType: 'water',
            stylers: [
                { hue: '#0078FF' },
                { saturation: -13.200000000000003 },
                { lightness: 2.4000000000000057 },
                { gamma: 1 }
            ]
        },
        {
            featureType: 'poi',
            stylers: [
                { hue: '#00FF6A' },
                { saturation: -1.0989010989011234 },
                { lightness: 11.200000000000017 },
                { gamma: 1 },
                { visibility: 'off' }
            ]
        }
    ];

    var googleMaps = function() {
        this.googleMaps = {};
    };

    googleMaps.prototype = {
        map: false,

        // Display Cluster Markers
        includeClusterMarkers: true,

        // Holds properties
        properties: [],
        infoWindow: false,

        // Map Marker
        icon: APP.map_marker,

        // Holds an array of markers to display on the map
        markCluster: false,
        markers: [],

        // Mark Cluster Options
        mcOptions: {
            gridSize: 50,
            maxZoom: 15,
            imagePath: APP.site_url + '/images/map/m'
        },

        // Initiates google maps view
        init: function(properties, id, includeClusterMarkers) {
            var supportedMapTypes = this.getSupportedMapTypes();

            // Ensure we have a valid google maps map-type defined
            if (!AI.googleMapsMapType || supportedMapTypes.indexOf(AI.googleMapsMapType) === -1) {
                AI.googleMapsMapType = CUSTOM_MAP_STYLE_ID;
            }

            // Take reference of the properties
            this.properties = properties;

            this.infoWindow = new google.maps.InfoWindow({
                maxWidth: 240
            });

            if (includeClusterMarkers == 'yes') {
                this.includeClusterMarkers = true;
            } else {
                this.includeClusterMarkers = false;
            }

            this.map = new google.maps.Map(document.getElementById(id), {
                center: { lat: 51.3375026, lng: -1.6271437 },
                zoom: 8,
                scrollwheel: false,
                mapTypeId: AI.googleMapsMapType,
                mapTypeControlOptions: {
                    mapTypeIds: supportedMapTypes
                }
            });

            // Set the styled map styling
            this.map.mapTypes.set(
                CUSTOM_MAP_STYLE_ID,
                new google.maps.StyledMapType(CUSTOM_MAP_STYLES, {
                    name: 'Styled Map'
                })
            );

            // Generate markers
            if (typeof this.properties !== 'undefined' && this.properties.length > 0) {
                this.generateMarkers(true);
            }

            google.maps.event.addListener(this.infoWindow, 'domready', function() {
                // Reference to the DIV which receives the contents of the infowindow using jQuery
                var iwOuter = $('.gm-style-iw');

                /* Since this div is in a position prior to .gm-div style-iw.
                 * We use jQuery and create a iwBackground variable,
                 * and took advantage of the existing reference .gm-style-iw for the previous div with .prev().
                 */
                var iwBackground = iwOuter.prev();

                // Removes background shadow DIV
                iwBackground.children(':nth-child(2)').css({ display: 'none' });

                // Removes white background DIV
                iwBackground.children(':nth-child(4)').css({ display: 'none' });

                // Changes the desired tail shadow color.
                iwBackground
                    .children(':nth-child(3)')
                    .find('div')
                    .children()
                    .css({ 'box-shadow': 'rgba(0, 0, 0, 0.6) 0px 1px 6px', 'z-index': '1' });

                // Reference to the div that groups the close button elements.
                var iwCloseBtn = iwOuter.next();

                // Apply the desired effect to the close button
                iwCloseBtn.css({
                    opacity: '1',
                    right: '10px',
                    top: '25px'
                });

                // The API automatically applies 0.7 opacity to the button after the mouseout event. This function reverses this event to the desired value.
                iwCloseBtn.mouseout(function() {
                    $(this).css({ opacity: '1' });
                });
            });
        },

        // Generate the markers to display
        generateMarkers: function(showTooltip) {
            var property, marker;
            var self = this;

            // Lat Long Bounds
            var bounds = new google.maps.LatLngBounds();

            // Loop over properties generating markers
            var properties_count = this.properties.length;
            for (var i = 0; i < properties_count; i++) {
                property = this.properties[i];
                // Don't show properties that do not have lat / long set correctly!
                if (property.lat === 0 && property.lng === 0) {
                    continue;
                }

                var title = 'Property: ' + property.name + ' ' + property.town;

                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(property.lat, property.lng),
                    map: self.map,
                    title: title,
                    icon: self.icon,
                    property: property
                });

                if (showTooltip) {
                    marker.addListener('click', function() {
                        self.openMarker(this);
                    });
                }

                bounds.extend(marker.position);
                this.markers.push(marker);
            }

            // If we have tonnes of markers, use markerCluster
            if (this.markers.length > 100 && this.includeClusterMarkers) {
                this.markCluster = new MarkerClusterer(this.map, [], this.mcOptions);
                this.markCluster.addMarkers(this.markers, true);
            }

            if (this.markers.length == 1) {
                // Center map on marker
                this.map.setCenter(
                    new google.maps.LatLng(this.properties[0].lat, this.properties[0].lng)
                );
                this.map.setZoom(15);
            } else {
                this.map.fitBounds(bounds);
            }
        },

        getSupportedMapTypes: function() {
            return [
                google.maps.MapTypeId.ROADMAP,
                google.maps.MapTypeId.SATELLITE,
                CUSTOM_MAP_STYLE_ID
            ];
        },

        openMarker: function(marker) {
            // Grab the content
            var p = marker.property;

            // Open the window
            this.setProperty(p);
            this.infoWindow.open(this.map, marker);
        },

        setProperty: function(property) {
            var image = '';

            if (Array.isArray(property.images) && property.images.length > 0) {
                image = '';
                if (property.images[0].image_sources != undefined) {
                    // AI
                    image = property.images[0].image_sources.front_back_large;
                } else {
                    // AS
                    image = property.images[0].url;
                }
            } else if (!Array.isArray(property.images) && property.images instanceof Object) {
                image = property.images.front_back_large;
            } else if (image == '' && property.default_images != undefined) {
                image = property.default_images.front_back_large;
            } else if (property.images != '') {
                image = property.images;
            }

            if (image) {
                image =
                    '<img src="' + image + '" alt="Image Coming Soon" width="120" height="80"></a>';
            }

            var name = property.name;
            var town = property.town;
            var url = property.url ? property.url : APP.properties_url + '/' + property.meta_id;

            var contentString =
                '<div id="google-popup">' +
                '<a class="featured-image" href="' +
                url +
                '">' +
                image +
                '</a>' +
                '<div class="google-popup-content">' +
                '<span class="town">' +
                town +
                '</span><br>' +
                '<span class="name">' +
                name +
                '</span><br>' +
                '<a target="_blank" href="' +
                url +
                '" class="details">More details</a>' +
                '</div>' +
                '</div>';

            this.infoWindow.setContent(contentString);
        }
    };

    AI.googleMaps = new googleMaps();
})(AI);



// WEBPACK FOOTER //
// ./resources/assets/js/ai/property-map.js